module.exports = __webpack_public_path__ + "img/folder-pink.ca4eda18.svg";